export const getBookletId = state => state.booklet.id;
export const getSectionId = index => state => state.booklet.sections[index].id;
export const getSection = index => state => state.booklet.sections[index];
export const getSectionLayouts = index => state =>
  state.booklet.sections[index].layouts;
export const getSectionFragmentChildrenLength = (
  sectionIndex,
  fragmentIndex
) => state =>
  state.booklet.sections[sectionIndex].fragments[fragmentIndex].children.length;



// WEBPACK FOOTER //
// ./src/selectors/booklet.selectors.js